import { Palette, Smartphone, Globe, Zap, Brain, Bot } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader } from './ui/card';
import { motion } from 'framer-motion';
import { useRef } from 'react';
import { useInView } from 'framer-motion';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';

const services = [
  {
    icon: Globe,
    title: "Web Design",
    description: "Moderne nettsider som konverterer besøkende til kunder",
    features: ["Responsiv design", "UX/UI optimalisering", "E-handel", "CMS løsninger"],
    image: "/webdesign.webp"
  },
  {
    icon: Smartphone,
    title: "App Design",
    description: "Intuitive mobile løsninger for iOS og Android",
    features: ["Native apps", "Cross-platform", "Prototyping", "User testing"],
    image: "/pomo_do.webp"
  },
  {
    icon: Brain,
    title: "AI Løsninger",
    description: "Skreddersydde AI-verktøy som effektiviserer din drift",
    features: ["Automatisering", "Dataanalyse", "Prediktive modeller", "Workflow-optimalisering"],
    image: "/fersken.webp"
  },
  {
    icon: Bot,
    title: "AI Chatbot",
    description: "Intelligente assistenter for 24/7 kundedialog",
    features: ["Døgnåpen support", "Lead-generering", "Booking-assistent", "Sømløs integrasjon"],
    image: "/ardoscuts.webp"
  },
  {
    icon: Palette,
    title: "Brand Design",
    description: "Omfattende merkevareidentitet som skiller deg ut i markedet",
    features: ["Logo design", "Visuell identitet", "Brand guidelines", "Merkestrategi"],
    image: "/theafragrance.webp"
  },
  {
    icon: Zap,
    title: "Digital Marketing",
    description: "Strategisk markedsføring som driver resultater",
    features: ["Sosiale medier", "SEO optimalisering", "Content strategi", "Analytics"],
    image: "/telegruppen.webp"
  }
]

export function Services() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "200px 0px 0px 0px" });

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <section id="tjenester" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-black">
            Våre Tjenester
          </h2>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto">
            Vi tilbyr helhetlige designløsninger som tar merkevaren din til neste nivå
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              variants={cardVariants}
              initial="hidden"
              animate={isInView ? "visible" : "hidden"}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group h-full"
            >
              <div className="h-full">
                {/* Info Section */}
                <div className="w-full h-full p-10 bg-black text-white flex flex-col rounded-xl border border-black/10 dark:border-white/10 shadow-lg group-hover:shadow-xl transition-all duration-300">
                  <div className="mb-8">
                    <h3 className="text-3xl font-bold mb-4">{service.title}</h3>
                    <p className="text-gray-400 text-sm leading-relaxed mb-6">
                      {service.description}
                    </p>
                  </div>
                  
                  <ul className="space-y-4 mt-auto">
                    {service.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center text-sm text-gray-300">
                        <div className="w-1.5 h-1.5 rounded-full bg-white/40 mr-3" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="text-center mt-16">
          <Link to="/tjenester">
            <Button size="lg" className="hero-glow smooth-transition hover:scale-105">
              Les Mer
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
